export default "__VITE_ASSET__CxTe7opm__"